const legacyToPhosphorIconMap = {
    brand: 'tag',
    grid: 'squares-four',
    home: 'house',
    product: 'package',
    users: 'users',
    link: 'link',
    'channel-share': 'share-network',
    device: 'devices',
    more: 'dots-three',
    'bar-graph': 'chart-bar',
};
export function legacyIconNameToPhosphorIconName(iconName) {
    return legacyToPhosphorIconMap[iconName] || iconName;
}
export function setOptionalIconName(target, iconName) {
    const maybeIconTarget = target;
    if (typeof maybeIconTarget?.setIconName === 'function') {
        maybeIconTarget.setIconName(iconName);
    }
}
